import React from 'react';
import Markdown from 'react-markdown';
import styled from 'styled-components';
import {
  COMMENT_MENTION_CLASSNAME,
  getCommentMentionUserId,
  isCommentMentionLink,
} from './comment-mention';

interface CustomMarkdownProps {
  text: string;
  className?: string;
  compact?: boolean;
}

const MarkdownWrapper = styled.div<{$compact?: boolean}>`
  min-width: 0;
  color: inherit;
  white-space: pre-wrap;

  p {
    margin: ${({$compact}) => ($compact ? '0' : '0 0 8px')};
  }

  p:last-child,
  ul:last-child,
  ol:last-child {
    margin-bottom: 0;
  }

  a {
    color: ${({theme}) => theme.colors.purple300};
    text-decoration: underline;
    overflow-wrap: anywhere;
  }

  strong {
    font-weight: 600;
  }
`;

export const CustomMarkdown = ({
  text,
  className,
  compact = false,
}: CustomMarkdownProps) => {
  return (
    <MarkdownWrapper className={className || 'text-[16px]'} $compact={compact}>
      <Markdown
        components={{
          a: ({href, children, node, ...props}) => {
            void node;

            return isCommentMentionLink(href) ? (
              <span
                className={COMMENT_MENTION_CLASSNAME}
                data-mention-user-id={getCommentMentionUserId(href)}>
                {children}
              </span>
            ) : (
              <a href={href} {...props}>
                {children}
              </a>
            );
          },
          ul: ({...props}) => (
            <ul
              style={{
                display: 'block',
                listStyleType: 'disc',
                whiteSpace: 'normal',
                paddingInlineStart: '18px',
                marginBottom: compact ? 0 : '8px',
              }}
              {...props}
            />
          ),
          ol: ({...props}) => (
            <ol
              style={{
                display: 'block',
                listStyleType: 'decimal',
                paddingInlineStart: '18px',
                marginBottom: compact ? 0 : '8px',
              }}
              {...props}
            />
          ),
        }}>
        {text}
      </Markdown>
    </MarkdownWrapper>
  );
};
